import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

import { useAuthentication } from '@hooks/useAuthentication'
import { useCategories } from '@hooks/useCategories'
import { BookEnum } from '@interfaces/BookEnum'
import { usePenNameAction } from '@hooks/penName/usePenNameAction'
import { SearchFormProps, SearchFormPropsType } from './interface'

const bookType = [
  { value: BookEnum.NOVEL, label: 'นิยาย' },
  { value: BookEnum.MANGA, label: 'การ์ตูน' },
]

export function withSearchForm(Component: React.FC<SearchFormPropsType>) {
  function WithSearchForm(props: SearchFormProps) {
    const router = useRouter()
    const penNameClient = usePenNameAction()
    const { user } = useAuthentication()
    const { categories } = useCategories()
    const [advanceSearch, setAdvanceSearch] = useState<boolean>(
      router.query.advanceSearch === 'true'
    )

    const { data: penNameOptions = [] } = useQuery(
      ['pen-name-options', user?.id],
      () =>
        penNameClient.getPenNameOptions(user?.id).then(res =>
          res.map(row => ({
            ...row,
            value: String(row.value),
          }))
        ),
      { enabled: !!user.id }
    )

    function handleAdvanceSearchChange() {
      setAdvanceSearch((prev: boolean) => !prev)

      router.replace({
        pathname: router.pathname,
        query: {
          tab: 'myEbook',
          advanceSearch: !advanceSearch,
          text: router.query.text || '',
        },
      })
    }

    const pageProps = {
      ...props,
      bookType,
      categories,
      penNameOptions,
      advanceSearch,
      handleAdvanceSearchChange,
    }

    return <Component {...pageProps} />
  }

  return WithSearchForm
}
